import { useEffect, useMemo, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  fruitBaskets,
  getProduct,
  images,
  initialAddresses,
  products,
  serviceAreas,
  shakeProducts,
  timeSlots,
  weekdays,
} from "../data";
import { useApp } from "../store";
import {
  AddressCard,
  Brand,
  DeliveryCard,
  EmptyState,
  PageHeader,
  PrimaryButton,
  ProductCard,
  SectionTitle,
  StatusBadge,
} from "../components/UI";

import "../css/Help.css";
export function Help() {
  const faqs = [
    [
      "How does scheduled delivery work?",
      "Choose a product, frequency, delivery days, window and address once. We’ll use that schedule for future deliveries.",
    ],
    [
      "Are the shakes made fresh?",
      "Yes. Your shake is prepared fresh for your scheduled delivery window.",
    ],
    [
      "Do you use protein powder?",
      "No. Phase 1 shakes use natural ingredients such as milk, nuts, fruit, oats and roasted soybean.",
    ],
    [
      "How are fruits sourced?",
      "We purchase according to upcoming scheduled demand from nearby markets instead of holding large inventory.",
    ],
    [
      "Can I skip or cancel?",
      "Yes. You can skip one delivery, pause a recurring schedule, or cancel future deliveries.",
    ],
    [
      "What if a fruit is unavailable?",
      "We’ll notify you and confirm a suitable seasonal substitute or adjusted amount before delivery.",
    ],
  ];
  return (
    <div className="page-wrap narrow container-xl">
      <PageHeader
        title="Need help?"
        copy="Our small Pune team is here to make scheduled fresh delivery simple."
      />
      <div className="support-grid">
        <a href="https://wa.me/919876543210">
          <i className="fa-brands fa-whatsapp" />
          <span>WhatsApp support</span>
        </a>
        <a href="tel:+919876543210">
          <i className="fa-solid fa-phone" />
          <span>Call support</span>
        </a>
      </div>
      <SectionTitle title="Frequently asked questions" />
      <div className="accordion" id="faq">
        {faqs.map(([q, a], i) => (
          <div className="accordion-item" key={q}>
            <h2 className="accordion-header">
              <button
                className={`accordion-button ${i ? "collapsed" : ""}`}
                data-bs-toggle="collapse"
                data-bs-target={`#faq-${i}`}
              >
                {q}
              </button>
            </h2>
            <div
              id={`faq-${i}`}
              className={`accordion-collapse collapse ${i === 0 ? "show" : ""}`}
              data-bs-parent="#faq"
            >
              <div className="accordion-body">{a}</div>
            </div>
          </div>
        ))}
      </div>
      <a href="mailto:support@freshloop.in" className="btn btn-soft w-100 mt-4">
        Report a problem
      </a>
    </div>
  );
}

export default Help;
